import {
  IdObject,
  Nullable,
  PayoutType,
  PayoutStatus,
  SearchRequest,
  PayoutAdjustmentReason,
} from 'types';

import { Event } from '../event';
import { Employee } from '../employees';
import { AccountingCategory } from '../accounting/types';

export interface Payout extends IdObject {
  date: string;
  event?: Event;
  amount: number;
  notes?: string;
  type: PayoutType;
  eventId?: number;
  createdAt: string;
  employee: Employee;
  employeeId: number;
  updatedAt?: string;
  checkoutId?: number;
  categoryId?: number;
  receiptUrl?: string;
  status: PayoutStatus;
  reasonReject?: string;
  originalEvent?: Event;
  requestAmount?: number;
  originalEventId?: number;
  category?: AccountingCategory;
  adjustmentReason?: PayoutAdjustmentReason;
}

export interface TransformPayoutData {
  sales: Payout[];
  bonuses: Payout[];
  refunds: Payout[];
  advances: Payout[];
  disputes: Payout[];
  reimbursements: Payout[];
  paymentHistory: Payout[];
  negativeAdjustmentAndEarnigns: Payout[];
}

export interface PaymentHistory
  extends Pick<Payout, 'date' | 'notes' | 'employee' | 'employeeId'>,
    IdObject {
  total: number;
  items: Payout[];
  paymentMethodId?: Nullable<string>;
}

export interface CreatePayoutRequest
  extends Omit<
    Payout,
    | 'id'
    | 'event'
    | 'status'
    | 'employee'
    | 'createdAt'
    | 'employeeId'
    | 'reasonReject'
  > {
  employeeId?: number;
}

export interface PayoutListRequest {
  id?: string;
  types?: string;
  eventId?: string;
  onlyLead?: boolean;
  employeeId?: string;
  status?: PayoutStatus;
}

export interface ChangeStatusRequest extends IdObject {
  amount?: number;
  status: PayoutStatus;
  reasonReject?: string;
}

export interface EditPayoutRequest extends CreatePayoutRequest, IdObject {
  employeeId: number;
}

export interface CreatePayrollRequest {
  employeeId: number;
  payoutItems: number[];
}

export type PaymentHistoryRequest = IdObject & SearchRequest;

export const MinusPayoutTypes = [
  PayoutType.Misc,
  PayoutType.Refund,
  PayoutType.Advance,
  PayoutType.NegativeTip,
  PayoutType.FreeShipping,
  PayoutType.PrepaidAdvance,
  PayoutType.NegativeEarnings,
  PayoutType.NegativeAdjustment,
];

export interface PendingPayout {
  event: Event;
  payoutItems: Payout[];
  totalPayoutAmount: number;
}

export interface EmployeeSalaryRequest extends IdObject {
  isUnpaidOnly?: boolean;
}
